import UserModel from '@/models/UserModel';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AxiosResponse } from 'axios';
import router from '../router';
import AxiosService from './../services/AxiosService';

export class TelemetryService {
  private static appInsights: ApplicationInsights;
  private static serviceName: string;
  private static serviceNameAr: string;
  private static cnfresult: AxiosResponse<any>;

  private static async FillConfig() {
    const axios = new AxiosService();
    let result: any = {};
    if (this.cnfresult) {
      result = this.cnfresult;
    } else {
      result = await axios.axiosInstance.get('api/cnf');
      this.cnfresult = result;
    }

    const options: any = {
      id: result.data.ApplicationInsights.InstrumentationKey,
      routerValue: router,
      trackInitialPageView: true,
      onAfterScriptLoaded: (data: any) => {
        data.addTelemetryInitializer((envelope: any) => {
          envelope.data.applicationName =
            result.data.ApplicationInsights.InstrumentationKey;
          if (typeof envelope.baseData === 'string') {
            const name = envelope.baseData;
            envelope.baseData = {};
            envelope.baseData.name = name;
          }
        });
      },
    };

    this.serviceName = result.data.ApplicationInsights.serviceName;
    this.serviceNameAr = result.data.ApplicationInsights.serviceNameAr;

    const config = options.appInsightsConfig || {};
    config.instrumentationKey = config.instrumentationKey || options.id;

    if (options.appInsights) {
      this.appInsights = options.appInsights;
    } else {
      this.appInsights = new ApplicationInsights({ config });
      this.appInsights.loadAppInsights();
      if (typeof options.onAfterScriptLoaded === 'function') {
        options.onAfterScriptLoaded(this.appInsights);
      }
    }

    const routerlocal = options.router;

    // Watch route event if router option is defined.
    if (routerlocal) {
      if (options.trackInitialPageView !== false) {
        this.setupPageTracking(options);
      } else {
        routerlocal.onReady(() => this.setupPageTracking(options));
      }
    }
  }

  // public static async  trackEvent(userInfo: UserModel, eventName: string, isSuccess: boolean, serNameAr: string, serNameEn: string, serType: string)
  public static async trackEvent(
    userInfo: UserModel,
    eventName: string,
    isSuccess: boolean,
    serType: string
  ) {
    // console.log("from trackEvent", userInfo);
    let userId = 'Anonymous';
    let nationality = 'Anonymous';
    let age: number = 0;
    let gender = 'Anonymous';
    //let birthDateHijri = 'Anonymous';

    if (userInfo) {
      userId = userInfo.userId;
      gender = userInfo.gender == '1' ? 'M' : 'F';
      nationality = userInfo.nationalityName;
      //birthDateHijri = userInfo.birthDateHijri;
      age = userInfo.age;
    }

    await this.FillConfig();
    // console.log("from trackEvent appInsights" ,this.appInsights);
    let obb = {
      userId: `${userId}`,
      nationality: `${nationality}`,
      //birthDateHijri: `${birthDateHijri}`,
      age: `${age}`,
      gender: `${gender}`,
      serviceNameAr: this.serviceNameAr,
      serviceName: this.serviceName,
      serviceType: serType,
      isSuccessful: isSuccess,
    };

    //console.log("from trackEvent appInsights" ,obb);

    this.appInsights.trackEvent({ name: `mojCE.wekalat.${eventName}` }, obb);
  }

  private static setupPageTracking(options: any) {
    const routerValue = options.routerValue;
    const baseName = options.baseName || '(Vue App)';

    routerValue.beforeEach((route: any, from: any, next: any) => {
      const name = baseName + ' / ' + route.name;
      this.appInsights.startTrackPage(name);
      next();
    });

    routerValue.afterEach((r: { name: string; fullPath: string }) => {
      const name = baseName + ' / ' + r.name;
      const url = location.protocol + '//' + location.host + r.fullPath;
      this.appInsights.stopTrackPage(name, url);
      this.appInsights.flush();
    });
  }
}
